var render = function render(){var _vm=this,_c=_vm._self._c;return _c('email-form',{attrs:{"error":_vm.verifyError,"form-info":_vm.$options.i18n.guidance,"submit-text":_vm.$options.i18n.updateEmail},on:{"submit-email":_vm.updateEmail,"cancel":() => _vm.$emit('verifyToken')}})
}
var staticRenderFns = []

export { render, staticRenderFns }